import { ICollectionInfo } from '../../app/spaces/Collections/ICollectionInfo';
import { Messages } from '../../codegen/Localize';
import { IErrorDetail } from '../../commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { CollectionsErrorCode } from '../helpers/ErrorCodes';
import { IContentInfo } from '../models/IContentInfo';


function errorDetailsFor(collectionErrorItem: IErrorItem<IContentInfo<'collection'>>): IErrorDetail {
    return {
      itemName: collectionErrorItem.item.name,
      errorMessage: this.errorMessageFor(collectionErrorItem)
    };
}

function errorMessageFor(errorItem: IErrorItem<ICollectionInfo>): string {
    switch (errorItem.error.code) {
        case CollectionsErrorCode.DUPLICATE_KEY:
            return Messages.createCollectionNameDuplicateError();
        case CollectionsErrorCode.INVALID_NAME_NULL:
        case CollectionsErrorCode.INVALID_NAME_WHITESPACE:
            return Messages.createCollectionNameWhitespaceError();
        case CollectionsErrorCode.INVALID_NAME_TOO_LONG:
            return Messages.createCollectionNameTooLongError();
        case CollectionsErrorCode.UNAUTHORIZED:
            return Messages.errorCollectionInsufficientPermissions();
        default:
            return Messages.errorUnknown();
    }
}

export const CollectionErrors = {
    errorDetailsFor,
    errorMessageFor
};
